export function isMappedSigrcPhoneOccurrence (resume: MappedSigrcPhoneOccurrence | SigRcResumeData): resume is MappedSigrcPhoneOccurrence {
    return (resume as MappedSigrcPhoneOccurrence).sigrcId !== undefined;
}
